import * as React from 'react';
import ProductDetails from '../../components/forms/ProductDetails';
import Section from '../../components/Section';
import { Product } from '../../product';
import HelpHint from '../../components/HelpHint';

type Props = {
  product: Product;
  setProduct: Function;
};

const setValue = (obj: Product, onChange: Function) => (
  field: string,
  newValue: any,
) =>
  onChange(
    Object.assign({}, obj, {
      [field]: newValue,
    }),
  );

const coffeeBeansDetails = [
  { name: 'Country', value: '' },
  { name: 'Varietal', value: '' },
  { name: 'Region', value: '' },
  { name: 'Producer', value: '' },
  { name: 'Farm', value: '' },
  { name: 'Processing Method', value: '' },
  { name: 'Altitude (masl)', value: '' },
  { name: 'Taste Notes', value: '' },
  { name: 'Cup Score', value: '' },
];

const coffeeScaleDetails = [
  { name: 'Accuracy', value: '0.1g' },
  { name: 'Minimum Weight', value: '0.1g' },
  { name: 'Maximum Weight', value: '2Kg' },
  { name: 'Bluetooth Support', value: 'Yes' },
];

const electricGrinderDetails = [
  { name: 'Bean Hopper Capacity', value: '' },
  { name: 'Grounds Bin Capacity', value: '' },
  { name: 'Burrs Size', value: '' },
  { name: 'Weight', value: '' },
];

export default function ProductDetailsInfo(props: Props) {
  const handleOnChange = setValue(props.product, props.setProduct);

  return (
    <Section title="Product Details" id="details">
      <div className="flex flex-wrap">
        <div className="flex-auto w-70-ns w-100 pr2">
          <ProductDetails
            field={['details']}
            label="Details"
            defaultValue={props.product.details}
            onValueChange={handleOnChange}
          />
        </div>
        <div className="flex-auto w-30-ns w-100 pl2">
          <HelpHint>
            List out all the aspects of the product you are selling. For
            example, for coffee beans include things like: Country of Origin,
            Varietal, Processing Method, Name of the Farmer/Mill etc.
            <br />
            <br />
            Use the templates listed below. This will ensure your product
            appears in relevant searches:
          </HelpHint>
          <div className="flex flex-column">
            <button
              className="tl f5 link dim br-pill bg-white-10 ph3 pv2 mb2 gold bw0 pointer"
              onClick={() =>
                handleOnChange(
                  'details',
                  props.product.details.concat(coffeeBeansDetails),
                )
              }
              type="button"
            >
              Coffee Beans
            </button>
            <button
              className="tl f5 link dim br-pill bg-white-10 ph3 pv2 mb2 gold bw0 pointer"
              onClick={() =>
                handleOnChange(
                  'details',
                  props.product.details.concat(coffeeScaleDetails),
                )
              }
              type="button"
            >
              Coffee Scale
            </button>
            <button
              className="tl f5 link dim br-pill bg-white-10 ph3 pv2 mb2 gold bw0 pointer"
              onClick={() =>
                handleOnChange(
                  'details',
                  props.product.details.concat(electricGrinderDetails),
                )
              }
              type="button"
            >
              Electric Grinder
            </button>
          </div>
        </div>
      </div>
    </Section>
  );
}
